/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pm_Confirm_TitleInputs */

const cs_pm_confirm_title = /** @type {(inputs: Pm_Confirm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uložit ID inzerátů?`)
};

const en_pm_confirm_title = /** @type {(inputs: Pm_Confirm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save listing IDs?`)
};

/**
* | output |
* | --- |
* | "Save listing IDs?" |
*
* @param {Pm_Confirm_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pm_confirm_title = /** @type {((inputs?: Pm_Confirm_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pm_Confirm_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pm_confirm_title(inputs)
	return cs_pm_confirm_title(inputs)
});